import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { closeModal } from "../../reducers/modalReducer";
import { Feedback } from "@allaria-tech/matter/Feedback";
import useMobileLayout from "../../hooks/useMobileLayout";

interface DniValidationErrorModalProps {
  title?: string;
  description?: string;
  onRetry?: () => void;
  onClose?: () => void;
  modalName?: string;
}

const DniValidationErrorModal = ({
  title = "Error",
  description = "Error",
  onRetry,
  onClose,
  modalName: modalNameProp,
}: DniValidationErrorModalProps) => {
  const dispatch = useAppDispatch();
  const { modalName } = useAppSelector((state) => state.modal);
  const { isCryptoAppModal } = useMobileLayout();

  const dismiss = () => dispatch(closeModal());

  const handleClose = () => {
    dismiss();
    onClose?.();
  };

  const handleRetry = () => {
    dismiss();
    onRetry?.();
  };

  return (
    <Feedback
      isOpen={modalName === modalNameProp}
      type="ERROR"
      title={title}
      description={description}
      onClose={dismiss}
      // In the app's 560px desktop modal our width reads as a phone, so keep
      // the desktop card there; its frame grows to fit it, so no 85vh cap.
      disableMobileLayout={isCryptoAppModal}
      disableMaxHeight={isCryptoAppModal}
      primaryAction={{ text: "Volver a intentar", onClick: handleRetry }}
      secondaryAction={{ text: "Cerrar", onClick: handleClose }}
    />
  );
};

export default DniValidationErrorModal;
